/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnregisterIBANOutput
 */
export interface UnregisterIBANOutput {
    /**
     * 
     * @type {number}
     * @memberof UnregisterIBANOutput
     */
    id?: number;
    /**
     * 
     * @type {Error}
     * @memberof UnregisterIBANOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UnregisterIBANOutput interface.
 */
export function instanceOfUnregisterIBANOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UnregisterIBANOutputFromJSON(json: any): UnregisterIBANOutput {
    return UnregisterIBANOutputFromJSONTyped(json, false);
}

export function UnregisterIBANOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnregisterIBANOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UnregisterIBANOutputToJSON(value?: UnregisterIBANOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'error': value.error,
    };
}

